export interface SocialMedia {
  instagram?: string;
  facebook?: string;
  tiktok?: string;
}

export interface Measurements {
  height?: string;
  weight?: string;
  tshirtSize?: string;
  pant?: string;
  shoeSize?: string;
}

export interface TalentFormData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  phone_country: string;
  password: string;
  confirmPassword: string;
  date_of_birth: string;
  nationality: string;
  city: string;
  bio: string;
  specialties: string[];
  experience_years: string;
  portfolio: string;
  socialMedia: SocialMedia;
  measurements: Measurements;
  languages: string[];
  custom_language: string;
  dialects: string[];
  skin_tone: string;
  hair_type: string;
  eye_color: string;
  hair_color: string;
  body_type: string;
  categories: string[];
  specialty_options: number[];
  look_alike: string;
  rates: string;
  gallery: File[];
}

export type TalentFormErrors = Partial<Record<keyof TalentFormData, string>>;

export const EMPTY_FORM: TalentFormData = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  phone_country: "EG",
  password: "",
  confirmPassword: "",
  date_of_birth: "",
  nationality: "",
  city: "",
  bio: "",
  specialties: [],
  experience_years: "",
  portfolio: "",
  socialMedia: {},
  measurements: {},
  languages: [],
  custom_language: "",
  dialects: [],
  skin_tone: "",
  hair_type: "",
  eye_color: "",
  hair_color: "",
  body_type: "",
  categories: [],
  specialty_options: [],
  look_alike: "",
  rates: "",
  gallery: [],
};
